import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to handle anchor link scrolling when page loads with hash
 * or when hash changes
 */
export const useAnchorScroll = () => {
  const location = useLocation();

  useEffect(() => {
    const handleAnchorScroll = () => {
      const hash = location.hash.replace('#', '');
      if (hash) {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ 
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 100);
      }
    };

    // Handle initial load and hash changes
    handleAnchorScroll();
    
    // Listen for hash changes
    const handleHashChange = () => {
      handleAnchorScroll();
    };
    
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [location.hash]);
};
